export const PATHS = {
  showcase: '/',
  products: 'products',
  admin: '/admin/',
  settings: 'settings',
  orders: 'orders',
  wishlist: '/wishlist',
  cart: '/cart',
  success: 'success',
  feed: '/feed'
};
